/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useMemo, useState } from 'react'
import useNotifSettings from 'tennders-notifications/hooks/useNotifSettings'
import useSession from 'tennders-auth/hooks/useSession'
import GCheckBox from 'tennders-common/form/components/checkbox'
import GHref from 'tennders-market/common/components/element/GHref'
import Switch from 'react-ios-switch'
import Select, { MultiValue } from 'react-select'
import { apiPut } from 'tennders-stracture/libs/api'
import { retry } from '@reduxjs/toolkit/query'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

const initialState = {
  groupedNotifications: false,
  selectedTimings: [],
  initialized: false
}
const groupedNotificationsOptions = [
  { label: '9AM Each day', value: 9 } as never,
  { label: '2PM Each day', value: 14 } as never,
  { label: '5PM Each day', value: 17 } as never
]
const NotifSettings = ({ notifTypes }) => {
  const [form, setform] = useState({})
  const [isExpanded, setIsExpanded] = useState(false)
  const { saveNotifSettings } = useNotifSettings()
  const { user, setUser } = useSession()
  const [groups, setGroups] = useState([])
  const { t } = useTranslation()
  const [state, setState] = useState(initialState)

  useEffect(() => {
    if (user?.notificationTimings) {
      setState(prev => (prev.initialized ? prev : ({
        groupedNotifications: user?.notificationTimings?.enabled || false,
        selectedTimings: user?.notificationTimings?.timings?.map(item => groupedNotificationsOptions.find(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          option => option.value === item
        )) || [],
        initialized: true
      })))
    }
  }, [user])

  const sendSettings = async (state) => {
    try {
      const data = await apiPut('/notifs/timings', {
        enabled: state.groupedNotifications,
        timings: state.selectedTimings.map(item => item.value)
      })

      if (data.id) {
        return true
      }
      return false
    } catch (e) {
      return false
    }
  }

  const onChange = (k, v) => {
    const parts = k.split(':')
    if (parts.length < 3) {
      return
    }
    const f = { ...form }
    const part1 = f[parts[0].trim()][parts[1].trim()]
    const part2 = parts[2].trim()
    if (v && !part1.includes(part2)) {
      part1.push(part2)
    } else if (!v) {
      const indexOf = part1.indexOf(part2)
      if (indexOf > -1) {
        delete part1[indexOf]
      }
    }
    setform({ ...form, ...f })
    saveNotifSettings(f)
  }

  useEffect(() => {
    if (user && notifTypes) {
      if (user?.notifSettings) {
        const notifGroups = []
        for (const group in user?.notifSettings) {
          const items = user?.notifSettings[group]
          const notifs = []
          for (const key in items) {
            notifs.push({
              name: notifTypes[key],
              key,
              email: items[key].indexOf('email') > -1,
              push: items[key].indexOf('push') > -1
            })
          }
          notifGroups.push({ name: t(`notifications:${group}`), key: group, items: notifs })
        }
        setGroups(notifGroups)
      }
      setform({ ...form, ...user.notifSettings })
    }
  }, [user, notifTypes])

  const notificationRows = () => {
    const rows = []
    groups.forEach((group) => {
      if (group?.items?.length > 0) {
        rows.push(
          <tr key={group.key}>
            <td colSpan={3}><strong>{group.name}</strong></td>
          </tr>
        )
        group.items.forEach((item) => (
          rows.push(
            <tr key={item.key}>
              <td><Trans i18nKey={`notif:${item.name}`} /></td>
              <td data-key={`${group.key}-${item.key}`} className="text-center">
                <GCheckBox
                  switchMode
                  key={`ntype${item.name}`}
                  onChange={onChange}
                  value={form[group.key]?.[item.key].includes('api')}
                  name={`${group.key}:${item.key}:api`}
                />
              </td>
              <td className="text-center">
                <GCheckBox
                  switchMode
                  key={`ntype${item.name}`}
                  onChange={onChange}
                  value={form[group.key]?.[item.key].includes('email')}
                  name={`${group.key}:${item.key}:email`}
                />
              </td>
            </tr>
          )
        ))
      }
    })
    return rows
  }

  return (
    <div className="tennders-user-menu-right-section">
      <GHref
        onClick={() => setIsExpanded(!isExpanded)}
        className={`tennders-user-menu-right-section-open-detail-btn${isExpanded ? ' opened' : ''}`}
      >
        <span>{t('menus:chooseNotifSettings')}</span>
        <FontAwesomeIcon icon={faChevronDown} aria-hidden="true" />
      </GHref>
      <div className={`tennders-user-menu-right-section-open-detail ${isExpanded ? ' opened' : ''}`}>
        <table className="tennders-notif-settings-table">
          <tbody>

            {state.initialized ? (
              <>
                <tr>
                  <td>
                    {t('notif:groupedNotification')}
                  </td>
                  <td>
                    <Switch
                      onChange={(checked: boolean) => {
                        const st = {
                          groupedNotifications: checked,
                          selectedTimings: state.selectedTimings,
                          initialized: true
                        }
                        setState((prev) => (st))
                        setTimeout(() => sendSettings(st), 200)
                      }}
                      checked={state.groupedNotifications} />
                  </td>
                </tr>

                <tr>
                  <td>
                    {t('notif:notificationTimings')}
                  </td>
                  <td>
                    <Select
                      isMulti
                      defaultValue={state.selectedTimings}
                      onChange={(selected) => {
                        const st = {
                          groupedNotifications: state.groupedNotifications,
                          selectedTimings: selected as any,
                          initialized: true
                        }
                        setState((prev) => (st))
                        setTimeout(() => sendSettings(st), 100)
                      }}
                      options={groupedNotificationsOptions} />
                  </td>
                </tr>

              </>
            ) : null}
            <tr>
              <th>{' '}</th>
              <th className="bold">{t('menus:push')}</th>
              <th className="bold">{t('menus:email')}</th>
            </tr>
            {notificationRows()}

          </tbody>
        </table>
      </div>
    </div>
  )
}

export default NotifSettings
